import React, { useState, useEffect } from 'react';
import './HeroSection.css';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroContent = [
    {
      image: '/images/sp5.jpeg',
      title: 'राष्ट्र निर्माण',
      subtitle: 'देश प्रेम',
      description: 'देश और राष्ट्र की सुरक्षा ही असली स्वातंत्र्य है।',
    },
    {
      image: '/images/sp8.jpeg',
      title: 'सनातन',
      subtitle: 'सनातन धर्म',
      description: 'सनातन धर्म का प्रचार या प्रसार यही जीवन का कर्तव्य होना चाहिए।',
    },
    {
      image: '/images/sidhisoch focus.png',
      title: 'जनसेवा',
      subtitle: 'समाज सेवा',
      description: 'समाज और विकास के लिए समर्पित।',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroContent.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroContent.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroContent.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroContent.length) % heroContent.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="hero-section">
      <div className="hero-carousel">
        {heroContent.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide${index === currentSlide ? ' active' : ''}`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              className="hero-main-img"
            />
            <div className="hero-gradient-overlay" />
            <div className="hero-text-overlay">
              <h1 className="hero-main-title">{slide.title}</h1>
              <div className="hero-main-slogan">"{slide.subtitle}"</div>
              <div className="hero-main-desc">{slide.description}</div>
            </div>
            <button className="carousel-nav prev" onClick={prevSlide} aria-label="Previous">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6"/>
              </svg>
            </button>
            <button className="carousel-nav next" onClick={nextSlide} aria-label="Next">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 6 15 12 9 18"/>
              </svg>
            </button>
          </div>
        ))}
        <div className="carousel-dots">
          {heroContent.map((_, index) => (
            <button
              key={index}
              className={`dot${index === currentSlide ? ' active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 